import angular from 'angular';

import {
  additionalFieldModelDirective,
  ddMaxlengthDirective,
  ddv4FixedHeaderDirective,
  ddv4TooltipDirective,
  ddvHideColumnDirective,
  ddvPannerDirective,
  draggableDirective,
  dragItemDirective,
  droppableDirective,
  dropZoneDirective,
  fileReadDirective,
  focusMeDirective,
  getterSetterDirective,
  jointFlowDirective,
  limitToDirective,
  ngModalSizeDirective,
  pwCheckDirective,
  scrollyDirective,
  selectOnFocusDirective,
  customTagsInputDirective,
  notificationToggleDirective,
  sidebarToggleDirective,
  linkedFilesSortableDirective,
} from '../directives';

const module = 'app.directives';
const requires = [];

angular.module(module, requires);

angular.module(module)
  .directive('additionalFieldModel', additionalFieldModelDirective)
  .directive('ddMaxlength', ddMaxlengthDirective)
  .directive('ddv4FixedHeader', ddv4FixedHeaderDirective)
  .directive('ddv4Tooltip', ddv4TooltipDirective)
  .directive('ddvHideColumn', ddvHideColumnDirective)
  .directive('ddvPanner', ddvPannerDirective)
  .directive('draggable', draggableDirective)
  .directive('dragItem', dragItemDirective)
  .directive('droppable', droppableDirective)
  .directive('dropZone', dropZoneDirective)
  .directive('fileRead', fileReadDirective)
  .directive('focusMe', focusMeDirective)
  .directive('getterSetter', getterSetterDirective)
  .directive('jointFlow', jointFlowDirective)
  .directive('limitTo', limitToDirective)
  .directive('ngModalSize', ngModalSizeDirective)
  .directive('pwCheck', pwCheckDirective)
  .directive('scrolly', scrollyDirective)
  .directive('selectOnFocus', selectOnFocusDirective)
  .directive('customTagsInput', customTagsInputDirective)
  .directive('notificationToggle', notificationToggleDirective)
  .directive('sidebarToggle', sidebarToggleDirective)
  .directive('linkedFilesSortable', linkedFilesSortableDirective);

export default module;